var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            ref: "heImg",
            staticClass: "hevue-imgpreview-wrap",
            attrs: { id: "hevue-imgpreview-wrap" },
            on: {
              mouseup: function($event) {
                return _vm.removeMove("pc")
              },
              touchend: function($event) {
                return _vm.removeMove("mobile")
              },
              click: function($event) {
                $event.stopPropagation()
                return _vm.clickMask.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "he-img-wrap" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.imgState === 1,
                      expression: "imgState === 1"
                    }
                  ],
                  staticClass:
                    "heimgfont hevue-img-status-icon rotate-animation"
                },
                [_vm._v("\n        \n      ")]
              ),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.imgState === 2,
                    expression: "imgState === 2"
                  }
                ],
                ref: "heImView",
                staticClass: "he-img-view",
                style:
                  "transform: scale(" +
                  _vm.imgScale +
                  ") rotate(" +
                  _vm.imgRotate +
                  "deg);margin-top:" +
                  _vm.imgTop +
                  "px;margin-left:" +
                  _vm.imgLeft +
                  "px;" +
                  _vm.maxWH,
                attrs: { src: _vm.imgurl },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  },
                  mousedown: _vm.addMove,
                  touchstart: _vm.addMoveMobile
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.imgState === 3,
                      expression: "imgState === 3"
                    }
                  ],
                  staticClass: "heimgfont hevue-img-status-icon"
                },
                [_vm._v("\n        \n      ")]
              ),
              _vm._v(" "),
              _vm.closeBtn
                ? _c(
                    "div",
                    {
                      staticClass: "heimgfont he-close-icon",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.close.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n        \n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrowBtn && _vm.multiple
                ? _c(
                    "div",
                    {
                      staticClass: "arrow arrow-left heimgfont",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toogleImg(false)
                        }
                      }
                    },
                    [_vm._v("\n        \n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.arrowBtn && _vm.multiple
                ? _c(
                    "div",
                    {
                      staticClass: "arrow arrow-right heimgfont",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toogleImg(true)
                        }
                      }
                    },
                    [_vm._v("\n        \n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.controlBar
                ? _c("div", { staticClass: "he-control-bar-wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass: "he-control-bar",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "he-control-btn heimgfont",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.scaleFunc(-0.15)
                              }
                            }
                          },
                          [_vm._v("\n            \n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "he-control-btn heimgfont",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.scaleFunc(0.15)
                              }
                            }
                          },
                          [_vm._v("\n            \n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isFull,
                                expression: "isFull"
                              }
                            ],
                            staticClass: "he-control-btn heimgfont",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.imgToggle.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("\n            \n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isFull,
                                expression: "!isFull"
                              }
                            ],
                            staticClass: "he-control-btn heimgfont",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.imgToggle.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("\n            \n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "he-control-btn heimgfont",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.rotateFunc(-90)
                              }
                            }
                          },
                          [_vm._v("\n            \n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "he-control-btn heimgfont",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.rotateFunc(90)
                              }
                            }
                          },
                          [_vm._v("\n            \n          ")]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.controlBar && _vm.multiple
                ? _c("div", { staticClass: "he-control-num" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.imgIndex + 1) +
                        " / " +
                        _vm._s(_vm.imgList.length) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05a9e385", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a9e385","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hevue-img-preview/hevue-img-preview.vue
// module id = null
// module chunks = 